import * as Sentry from '@sentry/react'
import { timestampWithMs } from '@sentry/utils'
import { FC, useEffect } from 'react'

/**
 * Adds a completed span to the scope transaction with the start set to the transaction start,
 * and closes it out.
 *
 * This cheeses the transaction to ensure its endtime matches this span's end time.
 */
export const DocRenderTracker: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  useEffect(() => {
    const transaction = Sentry.getCurrentHub().getScope()?.getTransaction()

    if (transaction) {
      transaction.startChild({
        description: 'Spans application doc load start till first render of EditorRenderer',
        op: 'almanac.doc-load',
        endTimestamp: timestampWithMs(),
        startTimestamp: transaction.startTimestamp,
      })
    }
  }, [])

  return <>{children}</>
}
